import React, { Component } from "react"
import Select from "react-select"
import { push } from "react-router-redux"
import { getListRoomVariantsPermalinks,
  moveDesignRoomToDestinationRoomVariant,
  checkEqualsDesignRoomRequest} from "../../../../api/lt-api"
import CopyDesignRoomFormStyle from "./style"
import { Button, ModalWindow } from "../../../Shared"
import { toastr } from "react-redux-toastr"
import PropTypes from "prop-types"
import StyledComponents from "../MoveModal/style"

class CopyDesignRoomForm extends Component {
  static propTypes = {
    openModal: PropTypes.func,
    closeModal: PropTypes.func,
    isModalOpen: PropTypes.bool,
    destination_room_id: PropTypes.number
  }

  state = {
    rooms: [],
    roomVariant: null,
    room_link: null,
    room: this.props.room,
    room_id: this.props.room_id,
    variant_id: this.props.variant_id,
    current_room_variant_id: this.props.current_room_variant_id,
    design_room_id: this.props.design_room_id,
    design_room: this.props.design_room,
    destination_room_id: null,
    destination_room_variant_id: null,
    selectedRoom: [],
    isModalOpen: false,
    isCopyModalOpen: false,
    query: '',
    typing: false,
    typingTimeout: 0
  }

  componentDidMount() {
    if (!this.props.isAuthenticated) {
      push("/login")
    }

    this.setState({
      isMounted: true,
      query: '',
      typing: false,
      typingTimeout: 0,
      rooms: [{permalink: '', id: 123}]
    })
  }

  handleChangeRoomPermalinkThrottled = (event) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      query: event,
      typing: false,
      typingTimeout: setTimeout(function () {
        self.handleChangeRoomPermalink(self.state.query);
      }, 600)
    });
  }

  getListRoomPermalinks = (rooms) => {
    return rooms.map((room) => (
      {label: room.permalink, value: room.product_id}
    ))
  }

  getSelectedListPermalinks = (itemsList, itemsIds = []) => {
    return itemsList.filter((item) => item.value === itemsIds)
  }

  openModal = () => {
    this.setState({
      isModalOpen: true,
      isCopyModalOpen: false
    })
  }

  closeModal = () => {
    this.setState({
      isModalOpen: false,
      isCopyModalOpen: false
    })
  }

  handleChangeRoomPermalink = (query) => {
    const toasterSuccess = "Success, the room variant's permalink successfully found"
    const toasterError = "Error, the room variant's permalink wasn't found"

    if (query.length > 0){
      getListRoomVariantsPermalinks(query)
        .then((response) => {
          toastr.success(toasterSuccess)

          const  rooms_links = response.data

          this.setState({
            rooms: rooms_links,
            room_id: rooms_links[0].id,
            destination_room_variant_id: rooms_links[0].product_id
          })
        })
        .catch((error) => {
          return toastr.error(toasterError)
        })
    }

  }

  getCheckedFurniture = (design_rooms, design_room_id) => {
    const design_room_products = design_rooms.filter((design_room) => design_room.design_room_id === design_room_id);

    const products = design_room_products.map((design_room) => design_room.values);

    return products[0].filter((product) => product !== null && product.is_checked_for_move === true).map((product) => product.furniture_id);
  };

  handleSubmitPermalinkRoom = (event) => {
    const toasterSuccess = "Success, the products of room successfully copied"
    const toasterError = "Error, the products of room weren't copied"
    const destination_room_variant_id = this.state.destination_room_variant_id
    const from_design_room_id = this.props.design_room_id
    const furniture_ids = this.getCheckedFurniture(this.props.products, from_design_room_id);
    const current_room_variant_id = this.props.current_room_variant_id


    if (destination_room_variant_id === null) {
      this.setState({
        message_title: 'You have not selected destination room variant!',
        message_content: 'Please select the destination room variant and try again.',
      });
      this.openModal();
    }
    if (furniture_ids.length === 0) {
      this.setState({
        message_title: 'You have not selected any products!',
        message_content: 'Please select at least one product and try again.',
      });
      this.openModal();
    }

    if (furniture_ids.length !== 0 && destination_room_variant_id !== null) {
      checkEqualsDesignRoomRequest(from_design_room_id, destination_room_variant_id)
        .then((response) => {
          const  isMoved = response.data.isMove
          if (!isMoved){
            const message = 'Current design room in this room variant are not in the new room variant.' +
              ' Products in the current design will be copied to Entire Unit. '

            this.setState({
              message_title: 'You are going to copy products to the selected one!',
              message_content: message,
              isCopyModalOpen: true,
              isModalOpen: true
            });
          }else{
            this.setState({
              isModalOpen: false
            })
            moveDesignRoomToDestinationRoomVariant(current_room_variant_id, destination_room_variant_id, from_design_room_id, furniture_ids)
              .then((response) => {
                toastr.success(toasterSuccess)
              })
              .catch((error) => {
                return toastr.error(toasterError)
              })
          }
        })
        .catch((error) => {
          return toastr.error(toasterError)
        })
    }
    event.preventDefault()
  }

  handleChangeRoomId = (target) =>{
    if (this.state.rooms.length !== 0){
      this.setState({
        room_id: target.value,
        destination_room_variant_id: target.value,
      })
      const listDesignRooms = this.getListRoomPermalinks(this.state.rooms)
      const room_value = this.getSelectedListPermalinks(listDesignRooms, target.value)
      this.setState({
          selectedRoom: room_value
        }
      )
    }
  }

  onSubmitModal = (event) => {
    const toasterSuccess = "Success, the products of room successfully copied"
    const toasterError = "Error, the products of room weren't copied"
    const destination_room_variant_id = this.state.destination_room_variant_id
    const from_design_room_id = this.props.design_room_id
    const furniture_ids = this.getCheckedFurniture(this.props.products, from_design_room_id);
    const current_room_variant_id = this.props.current_room_variant_id

    moveDesignRoomToDestinationRoomVariant(current_room_variant_id, destination_room_variant_id, from_design_room_id, furniture_ids)
      .then((response) => {
        toastr.success(toasterSuccess)
      })
      .catch((error) => {
        return toastr.error(toasterError)
      })
    this.closeModal()
  }

  render() {
    const {rooms, selectedRoom } = this.state
    const listDesignRooms = this.getListRoomPermalinks(rooms)
    const value = this.getSelectedListPermalinks(listDesignRooms, this.state.room_id)
    const { isModalOpen, isCopyModalOpen, message_title, message_content } = this.state
    const customStyles = {
      control: (provided) => ({
        ...provided,
        width: '100%',
        maxWidth: '240px',
        minWidth: '150px',
      }),
      menu: (provided) => ({
        ...provided,
        width: '100%',
        maxWidth: '240px',
      }),
      singleValue: (provided) => ({
        ...provided,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }),
      input: (provided) => ({
        ...provided,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }),
    };

    return (
      <CopyDesignRoomFormStyle>
        <form className="container-fluid" onSubmit={this.handleSubmitPermalinkRoom}>
          <div className="col-lg-9 pl-2 flex move__box-label">
            Copy to design:
          </div>
          <div className="col-lg-9 pl-2 flex move__box-select">
            <Select
              placeholder="Type and Select..."
              className={"select2-single"}
              options={listDesignRooms}
              onChange={this.handleChangeRoomId}
              onInputChange={this.handleChangeRoomPermalinkThrottled}
              value={selectedRoom || value}
              styles={customStyles}
            />
          </div>
          <div className="move__box-button">
            <Button type="submit" color="copy" size="medium" width={100} >
              Copy
            </Button>
          </div>
        </form>
        {isModalOpen && (
          <ModalWindow closeModal={this.closeModal}>
            <StyledComponents>
              <div className="modal__header">
                <h1 className="modal__title">Copy Products to another Proposal's Room Variant</h1>
              </div>
              <div className="row move-modal-content">
                <span className="modal__content">
                  {message_title}
                </span>
              </div>
              <div className="row move-modal-content">
                <span>
                  {message_content}
                </span>
              </div>
              {!(isCopyModalOpen) && (
                <div className="add-attributes__footer">
                  <Button type="button" width={120} onClick={this.closeModal}>
                    Cancel
                  </Button>
                </div>
              )}
              {isCopyModalOpen && (
                <div>
                  <div className="row center-text" style={{justifyContent: 'center'}}>
                    <p>Are you sure you want to copy this products to the new room variant ?</p>
                  </div>
                  <form noValidate className="add-attributes__form" onSubmit={this.onSubmitModal}>
                    <div className="add-attributes__footer">
                      <Button type="button" width={120} onClick={this.closeModal}>
                        Cancel
                      </Button>
                      <Button type="submit" width={120}>
                        Continue
                      </Button>
                    </div>
                  </form>
                </div>
              )}
            </StyledComponents>
          </ModalWindow>
        )}
      </CopyDesignRoomFormStyle>
    )
  }
}

export default CopyDesignRoomForm